"use client";

import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type SortableRenderProps = {
  attributes: Record<string, any>;
  listeners: Record<string, any>;
  setNodeRef: (element: HTMLElement | null) => void;
  isDragging: boolean;
};

export function SortableItem({
  id,
  wrapperId,
  dataBlockId,
  children,
  wrapperStyle,
}: {
  id: string;
  wrapperId?: string;
  dataBlockId?: string;
  children: (props: SortableRenderProps) => React.ReactNode;
  wrapperStyle?: (args: { id: string; isDragging: boolean }) => React.CSSProperties | undefined;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id });
  const customStyle = wrapperStyle?.({ id, isDragging });
  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: "relative",
    zIndex: isDragging ? 100 : undefined,
    opacity: isDragging ? 0 : 1,
    ...customStyle,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      id={wrapperId}
      data-block-id={dataBlockId}
    >
      {children({
        attributes: attributes ?? {},
        listeners: listeners ?? {},
        setNodeRef,
        isDragging,
      })}
    </div>
  );
}
